import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { SidecarEnvoyEditable } from "../../gvc/sidecar/editable";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";

export const WorkloadSidecarEnvoy: React.FC = () => {
  return (
    <div className="cpln-form-section cpln-ant-card-container">
      <Card>
        <CardTitle>
          Sidecar | Envoy
          <CpErrorWarningArrayIcon names={["sidecar"]} />
        </CardTitle>
        <CardContent>
          <SidecarEnvoyEditable />
        </CardContent>
      </Card>
    </div>
  );
};
